(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-main-section-old"]) return;
  try {
    
// Preview Card image Model Start
var previewImgModal = document.querySelector('.js-tingle-preview-card-image-btn');
var previewCardImageModal = new tingle.modal({
  footer: true,
  onOpen: function () {
    document.querySelector('body').classList.add('preview-card-image-active');
    document.querySelector('.tingle-modal-box').style.backgroundColor = "unset";
    document.querySelector(`.tingle-modal-box__content`).style.textAlign="center";
    // let previewCardImageUrl = document.querySelector('.js-tingle-preview-card-image-btn img').src;
    // document.querySelector(`.tingle-modal-box__content img`).src=previewCardImageUrl;
    document.querySelector(`.tingle-modal-box__footer`).style.display="none";
  },
  onClose: function () {
    document.querySelector('body').classList.remove('preview-card-image-active');
  }
});
// add a button

if (previewImgModal) {
  // [...document.querySelectorAll('.js-tingle-preview-card-image-btn')].forEach(function(item) {
  //   item.addEventListener('click', function () {
  //     document.querySelector('.modal-preview-card-image img').src = this.dataset.src;
  //     previewCardImageModal.setContent(document.querySelector('.modal-preview-card-image').innerHTML);
  //     previewCardImageModal.open();
  //   });
  // });
  [].slice.call(document.querySelectorAll('.js-tingle-preview-card-image-btn')).forEach(function (item) {
      item.addEventListener('click', function () {
        document.querySelector('.modal-preview-card-image img').src = this.getAttribute('data-src');
        previewCardImageModal.setContent(document.querySelector('.modal-preview-card-image').innerHTML);
        previewCardImageModal.open();
      });
  });
  // previewImgModal.addEventListener('click', function () {
  //   console.log(this);
  //   previewCardImageModal.setContent(document.querySelector('.modal-preview-card-image').innerHTML);
  //   previewCardImageModal.open();
  // });
}
// Preview Card image Model End

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fday-testimonial"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // let testimonial__name = $('.testimonial__name');
    //   if (testimonial__name.length > 0) {
    //     $.each(testimonial__name, function (index, element) {
    //       console.log(elements)
    //       $(element).closest('.testimonial__product--img').find('.profileImage').text($(element).text().split(' ').map(name => name[0]).join('').toUpperCase());
    //     });
    //   }
    /// Retrieve elements with the .testimonial__name class
    const testimonialNameElements = document.querySelectorAll('.testimonial__name');

    // Function to extract initials from a name
    function extractInitials(name) {
      return name
        .split(' ')
        .map((word) => word[0])
        .join(' ')
        .toUpperCase();
    }

    // Loop through each .testimonial__name element
    testimonialNameElements.forEach((element) => {
      const name = element.textContent; // Get the text content of the element
      const closestTestimonialProductImg = element.closest('.testimonial__product--img'); // Find the closest parent with class .testimonial__product--img

      if (closestTestimonialProductImg) {
        const profileImageElement = closestTestimonialProductImg.querySelector('.profileImage'); // Find the .profileImage element within the parent
        if (profileImageElement) {
          const initials = extractInitials(name); // Extract initials from the name
          profileImageElement.textContent = initials; // Set the initials as the text content of .profileImage
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-section"]) return;
  try {
    
  var stickyFreeshipBtn = document.querySelector('.free-shipping-section-truck');
  var stickyCheckoutBtn = document.querySelector('.btn-checkout');
  if (stickyCheckoutBtn != undefined) {
    stickyCheckoutBtn.classList.add('sticky');
  }
  window.addEventListener('scroll', function () {
    if (window.innerWidth <= 912) {
      var featureBoxOffset = document.querySelector('.hero_easter_frameboxes');
      if (featureBoxOffset != undefined) {
        let featureBoxOffsetTop = featureBoxOffset.getBoundingClientRect().top;
        var stickyBtn = document.querySelector('.sticky__btn');
        if (stickyBtn != undefined) {
          if (featureBoxOffsetTop - window.pageYOffset < -440) {
            stickyBtn.classList.add('sticky');
            stickyBtn.style.display = 'flex';
          } else {
            document.querySelector('.sticky__btn').style.display = 'none';
          }
        }
      }
      var ourCustomerBoxOffset = document.querySelector('.our-customer-box');
      if (ourCustomerBoxOffset != undefined) {
        let ourCustomerBoxOffsetTop = ourCustomerBoxOffset.getBoundingClientRect().top;
        if (ourCustomerBoxOffsetTop > 1640 || ourCustomerBoxOffsetTop < 870) {
          // stickyCheckoutBtn.classList.add('sticky');
          // stickyFreeshipBtn.classList.add('sticky');
          // stickyFreeshipBtn.style.display = 'flex';
        } else {
          // stickyFreeshipBtn.classList.remove('sticky');
          // stickyCheckoutBtn.classList.remove('sticky');
          // stickyFreeshipBtn.style.display = 'none';
        }
      }
      // var customiseBtn = document.querySelector('.customise__btn');
      // var sizeGuideWrapper = document.querySelector('.size__guide-wrapper');

      // if(sizeGuideWrapper != undefined){
      //   let customiseBtnTop = sizeGuideWrapper.getBoundingClientRect().top;
      //   console.log(customiseBtnTop);
      //   if (customiseBtnTop > 744 || customiseBtnTop  < -25 ) {
      //     customiseBtn.classList.add('sticky');
      //   } else {
      //     customiseBtn.classList.remove('sticky');
      //   }
      // }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moment-product-template"]) return;
  try {
    
(function() {
  // Variant switching fix
  document.addEventListener('change', function(e) {
    if (e.target.matches('input[type="radio"][name^="option"]')) {
      setTimeout(function() {
        var select = document.querySelector('select[name="id"]');
        if (select && select.value) {
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, 50);
    }
  });

  // Custom name field logic
  var nameInput = document.getElementById('custom-player-name');
  if (!nameInput) return;

  // Patch XHR to inject custom name into FormData before cart add
  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function(body) {
    if (this._url && this._url.includes('/cart/add')) {
      var name = nameInput.value.trim();
      if (name && body instanceof FormData) {
        // Find which item index is the main product (not the upsell)
        // Inject into all items that aren't the wall mounting kit
        var addedToItem = false;
        for (var pair of body.entries()) {
          // Find item indices e.g. items[1][id]
          var match = pair[0].match(/^items\[(\d+)\]\[id\]$/);
          if (match) {
            var index = match[1];
            body.append('items[' + index + '][properties][Custom Name]', name);
            addedToItem = true;
          }
        }
      }
    }
    return originalSend.call(this, body);
  };

  // Validation on ATC click
  document.querySelectorAll('[data-customize-product-link], [data-customize-product-link-desktop-button]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      var name = nameInput.value.trim();
      var errorEl = document.getElementById('custom-name-error');
      if (!name) {
        e.stopImmediatePropagation();
        e.preventDefault();
        errorEl.style.display = 'block';
        nameInput.style.borderColor = 'red';
        return false;
      }
      errorEl.style.display = 'none';
      nameInput.style.borderColor = '#E6E9EE';
    }, true);
  });

  // Clear error on typing
  nameInput.addEventListener('input', function() {
    document.getElementById('custom-name-error').style.display = 'none';
    nameInput.style.borderColor = '#E6E9EE';
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-product-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Splide('.testimonial__product-slider.splide', {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      gap: '16px',
      pagination: true,
      arrows: false,
      breakpoints: {
        991: {
          perPage: 2,
        },
        575: {
          perPage: 2,
        },
      },
    }).mount();

    let testimonial__name = $('.testimonial__product-slider .testimonial__name');
    if (testimonial__name.length > 0) {
      $.each(testimonial__name, function (index, element) {
        $(element)
          .closest('.testimonial__product--img')
          .find('.profileImage')
          .text(
            $(element)
              .text()
              .split(' ')
              .map((name) => name[0])
              .join('')
              .toUpperCase()
          );
      });
    }
    let testimonial__name_second = $('.testimonial__product-wrapper .testimonial__name');
    if (testimonial__name_second.length > 0) {
      $.each(testimonial__name_second, function (index, element) {
        $(element)
          .closest('.testimonial__product--img')
          .find('.profileImage')
          .text(
            $(element)
              .text()
              .split(' ')
              .map((name) => name[0])
              .join('')
              .toUpperCase()
          );
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-section-new"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Splide('.landing--review-slider', {
      type: 'loop',
      perPage: 1,
      gap: '16px',
      interval: 5000,
      speed: (number = 1100),
      perMove: 1,
      pagination: false,
    }).mount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slider-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var videoSlider = new Splide('.video-slider', {
      type: 'loop',
      perPage: 4,
      perMove: 1,
      gap: '2px',
      interval: 5000,
      speed: (number = 1100),
      breakpoints: {
        991: {
          perPage: 3,
          pagination: true,
        },
        575: {
          perPage: 2,
          gap: '2px',
          pagination: true,
        },
      },
    }).mount();
    videoSlider.on('move', function () {
      let videos = document.querySelectorAll('video');
      for (video of videos) {
        if (video) {
          video.pause();
        }
      }
    });
    let videos = document.querySelectorAll('video');
    for (video of videos) {
      if (video) {
        video.pause();
        video.onpause = function () {
          this.muted = true; // Unmute the video
          this.controls = false; // View controls
          let nextButton = this.nextElementSibling;
          nextButton.innerHTML = `<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="56" height="56" rx="28" transform="matrix(1 0 0 -1 0 56)" fill="black" fill-opacity="0.3"/>
                    <path d="M40 28L22 38.3923L22 17.6077L40 28Z" fill="white"/>
                  </svg>`; // Update button text
          nextButton.classList.remove('play');
        };
        video.onplay = function () {
          this.muted = false; // Unmute the video
          this.controls = true; // View controls
          let nextButton = this.nextElementSibling;
          nextButton.innerHTML = `<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="56" height="56" rx="28" transform="matrix(1 0 0 -1 0 56)" fill="black" fill-opacity="0.3"/>
                <rect x="20" y="17.6077" width="6" height="21.7846" rx="3" fill="white"/>
                <rect x="30" y="17.6077" width="6" height="21.7846" rx="3" fill="white"/>
              </svg>`; // Update button text
          nextButton.classList.add('play');
        };
      }
    }
    const playPauseButtons = document.querySelectorAll('.play-pause-button');
    playPauseButtons.forEach((button) => {
      button.addEventListener('click', function () {
        // Find the closest video element to the clicked button
        const closestVideo = this.previousElementSibling;
        this.innerHTML = ``; // Update button text
        if (closestVideo) {
          if (closestVideo.paused) {
            closestVideo.play(); // Play the video if it's paused
          } else {
            closestVideo.pause(); // Pause the video if it's playing
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
